import { fetchData } from "@request";

export type BankRegex = {
  id: string;
  regex: string;
  type: string;
  method: string;
  description: string;
};

export type BankRegion = {
  id?: number;
};

export type AdminBankRaw = {
  alias: string;
  bank_id_code: string;
  id: string;
  logo: string;
  name: string;
  phone_number: string;
  push_notification_packages: string[];
  regexes: BankRegex[];
  region: BankRegion;
  require_account_for_sbp: boolean;
  uniq_only: boolean;
  country: string;
  currency: string;
  type: string;
  method: string;
};

export type AdminBank = {
  alias: string;
  bank_id_code: string;
  id: string;
  logo: string;
  name: string;
  phone_number: string;
  push_notification_packages: string;
  regexes: BankRegex[];
  region: BankRegion;
  require_account_for_sbp: boolean;
  uniq_only: boolean;
  country: string;
  currency: string;
  type: string;
  method: string;
};

export type AdminBanksResponse = AdminBankRaw[];

// export type AdminBanksRequest = PaginationParameters<{
//   status?: AdminBankStatus;
//   type?: AdminBankType;
//   traderId?: string;
//   merchantId?: string;
// }>;

export const getAdminBanksApi = async (/* data?: AdminBanksRequest */) => {
  try {
    // const queryParams = getQueryParams(data);
    const response = await fetchData<AdminBanksResponse>({
      url: `api/v1/admin/banks`,
    });

    return response;
  } catch (error) {
    console.error("getAdminBanksApi failed:", error);
    throw error;
  }
};

export type RegexForm = {
  id?: string;
  regex: string;
  type: string;
  method: string;
  description: string;
};

export type CreateAdminBankRequest = {
  alias: string;
  bank_id_code: string;
  logo?: string;
  name: string;
  phone_number?: string;
  push_notification_packages?: string[];
  regexes: RegexForm[];
  region?: BankRegion | null;
  require_account_for_sbp?: boolean;
  uniq_only?: boolean;
  country?: string;
  currency?: string;
  type?: string;
  method?: string;
};

export const createAdminBankApi = async (data: CreateAdminBankRequest) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/banks`,
      method: "POST",
      data,
    });

    return response;
  } catch (error) {
    console.error("createAdminBankApi failed:", error);
    throw error;
  }
};

export type UpdateAdminBankRequest = {
  bank_id_code: string;
  logo?: string;
  name: string;
  phone_number?: string;
  push_notification_packages?: string[];
  regexes: RegexForm[];
  region?: BankRegion | null;
  require_account_for_sbp?: boolean;
  uniq_only?: boolean;
  country?: string;
  currency?: string;
  type?: string;
  method?: string;
};

export const UpdateAdminBankApi = async (
  bankId: string,
  data: UpdateAdminBankRequest
) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/banks/${bankId}`,
      method: "PUT",
      data,
    });

    return response;
  } catch (error) {
    console.error("updateAdminBankApi failed:", error);
    throw error;
  }
};

export const deleteAdminBankApi = async (bankId: string) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/banks/${bankId}`,
      method: "DELETE",
    });

    return response;
  } catch (error) {
    console.error("updateAdminBankApi failed:", error);
    throw error;
  }
};
